



























































































































































































































































































































































































































































































/* tslint:disable:no-console */
import DateField from '@/components/DateField.vue';
import TimeField from '@/components/TimeField.vue';
import DateTimeField from '@/components/DateTimeField.vue';
import CurrencyField from '@/components/CurrencyField.vue';
import NumberField from '@/components/NumberField.vue';
import CustomDateField from '@/components/CustomDateField.vue';
import {commitAddNotification} from '@/store/main/mutations';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { api } from '@/api';
import formatting from '@/formatting';
import { ChoiceOption, ChoiceOptionList } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';
import extensions from './HtmlExtensions';
import { TiptapVuetify } from 'tiptap-vuetify';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';
import moment from 'moment';

@Component({
  components: {
    DateField,
    TimeField,
    DateTimeField,
    CurrencyField,
    NumberField,
    CustomDateField,
    TiptapVuetify,
    DocPreviewDialog
  }
})
export default class DetailField extends Vue {
  // Props
  @Prop(String) public readonly label!: string;
  @Prop({ type: String, default: '' }) public readonly info!: string;
  @Prop(String) public readonly field!: string;
  @Prop(String) public readonly datesourcefield!: string;
  @Prop(String) public readonly apiDownloadUrl!: string;
  @Prop(String) public readonly prefix!: string;
  @Prop(String) public readonly suffix!: string;
  @Prop(String) public readonly link!: string;
  @Prop({ type: String, default: '' }) public readonly field2!: string;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: true }) public readonly clearable!: boolean;
  @Prop({ type: String, default: 'text' }) public readonly dataType!: string;
  @Prop({ type: String, default: 'choice' }) public readonly endpoint!: string;
  @Prop(Array) public readonly rules;
  @Prop(Object) public readonly validator!: object;
  @Prop({ type: Array, default: null }) public readonly optionList!: ChoiceOption[] | null;
  @Prop({ type: String, default: null }) public readonly optionListName!: string | null;
  @Prop({ type: Object, default: null }) public readonly optionListParams!: object | null;
  @Prop(Object) public readonly rec!: object;

  public finalOptionList: ChoiceOption[] = [];
  public extensions = extensions;
  public validateErrors: string[] = [];
  public myrules = {
    required: v => {
      if (typeof v === 'number') {
        return true;
      }
      return !!v || 'Dit veld is verplicht.';
    },
    // counter: v => v.length <= 20 || 'Max 20 characters',
    email: v => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (!v || pattern.test(v)) || 'Ongeldige e-mail.';
    },
    emails: v => {
      if (!v) {
        return true;
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      for (const part of v.replace(/\s/g, '').split(/,|;/)) {
            if (!pattern.test(part)) {
                return 'Ongeldige e-mail.';
            }
        }
      return true;
    }
  };
  public validationMessages = {
    vat: 'Ongeldig BTW nummer.',
    phone: 'Ongeldig telefoonnummer.',
    iban: 'Ongeldig IBAN nummer.'
  };
  public booleanNullItems = [
    {text: 'Ja', value: true},
    {text: 'Nee', value: false},
    {text: 'Ongewijzigd', value: null}
  ];
  public geoSubscriptionId = 0;
  public geoSubscriptionTimeStamp = 0;

  // Getters & setters
  public get allRules() {
    const rules = this.rules ? this.rules : [];
    if (this.required) {
      rules.push(this.myrules.required);
    }
    if (this.dataType === 'email') {
      rules.push(this.myrules.email);
    } else if (this.dataType === 'emails') {
      rules.push(this.myrules.emails);
    }
    return rules;
  }

  @Getter('getCachedChoice')
  public getCachedChoice!: (name: string) => ChoiceOptionList;

  @Mutation('setCachedChoice')
  public setCachedChoice;

  // Functions
  public formatTimeStamp(timestamp) {
    return formatting.formatTimeStamp(timestamp);
  }

  public async validateOnServer(v) {
    this.validateErrors.splice(0);
    if (v) {
      const response = await api.callValidator(this.$store, this.dataType, v);
      if (response.result) {
        if (this.rec[this.field] !== response.v) {
          this.rec[this.field] = response.v;
        }
      } else {
        this.validateErrors.push(this.validationMessages[this.dataType]);
      }
    } else {
    }
  }

  public async inputChanged(v) {
    if (this.dataType === 'vat' || this.dataType === 'phone' || this.dataType === 'iban') {
      this.validateOnServer(v);
    }
  }

  public async inputClear(v) {
    this.validateErrors.splice(0);
  }

  public onInput(value, isEnterEvent) {
    this.$emit('input', value);
    if (isEnterEvent) {
      this.$emit('enter', value);
    }
  }

  public nextElement(e) {
    const elem = e.target;
    const currentIndex = Array.from(elem.form.elements).indexOf(elem);
    let nextElem = elem.form.elements.item(
      currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
    );
    if (nextElem.tabIndex === -1) {
      // Skip element - clear icon
      nextElem = elem.form.elements.item(
        currentIndex < elem.form.elements.length - 2 ? currentIndex + 2 : 0
      );
    }
    nextElem.select();
    this.$emit('enter', e);
  }

  // Custom filter autocomplete to ignore spaces (trim)
  public customFilter(item, queryText, itemText) {
    return (
      itemText
        .toLocaleLowerCase()
        .indexOf(queryText.trim().toLocaleLowerCase()) > -1
    );
  }

  public setOptions() {
    if (this.optionList) {
      // Static option list
      this.finalOptionList = this.optionList;
    } else if (this.optionListName) {
      // Dynamic option list
      if (this.optionListParams) {
        // Don't cache
        this.getOptionList(this.optionListName, this.optionListParams);
      } else {
        this.getCachedOptionList(this.optionListName);
      }
    }
  }

  public findOptionValue() {
    if (this.finalOptionList) {
      const value = this.rec[this.field];
      let returnValue = '';
      this.finalOptionList.forEach(option => {
        if (option.value === value) {
          returnValue = option.text;
        }
      });
      return returnValue;
    }
  }
  public findOptionValueForId(id) {
    if (this.finalOptionList) {
      let returnValue = '';
      this.finalOptionList.forEach(option => {
        if (option.value === id) {
          returnValue = option.text;
        }
      });
      return returnValue;
    }
  }
  public findOptionRecForId(id) {
    if (this.finalOptionList) {
      let returnValue: ChoiceOption|null = null;
      this.finalOptionList.forEach(option => {
        if (option.value === id) {
          returnValue = option;
        }
      });
      return returnValue;
    }
  }

  public findOptionRec() {
    if (this.finalOptionList) {
      const value = this.rec[this.field];
      let returnValue: null|ChoiceOption = null;
      this.finalOptionList.forEach(option => {
        if (option.value === value) {
          returnValue = option;
        }
      });
      return returnValue;
    }
  }

  // Get option list from API
  public async getOptionList(optionListName, optionListParams) {
    const data = await api.getChoices(
      this.$store,
      '/' + optionListName + '/' + this.endpoint + '/',
      optionListParams
    );
    if (data) {
      this.finalOptionList = data.records;
    }
  }

  public isValidTimestamp(timestamp) {
    if (timestamp) {
      // Cache choice lists for 30 seconds
      return moment().diff(timestamp, 'seconds') < 30;
    } else {
      return false;
    }
  }

  // Get option list from cache
  public async getCachedOptionList(optionListName) {
    const cachedList: ChoiceOptionList = this.getCachedChoice(
      optionListName + '-' + this.endpoint
    );
    if (
      cachedList &&
      cachedList.timestamp &&
      this.isValidTimestamp(cachedList.timestamp)
    ) {
      this.finalOptionList = cachedList.records;
    } else {
      const checksum =
        cachedList && cachedList.checksum ? cachedList.checksum : '';
      const data = await api.getChoices(
        this.$store,
        '/' + this.optionListName + '/' + this.endpoint + '/',
        { checksum }
      );
      if (data) {
        if (data.records.length > 0) {
          data.timestamp = Date.now();
          // Update cache
          this.setCachedChoice({
            name: this.optionListName + '-' + this.endpoint,
            value: data
          });
          this.finalOptionList = data.records;
        } else {
          // Cache up-to-date
          if (cachedList) {
            cachedList.timestamp = Date.now();
            this.setCachedChoice({
              name: this.optionListName + '-' + this.endpoint,
              value: cachedList
            });
            this.finalOptionList = cachedList.records;
          } else {
            // Empty list
            this.finalOptionList = [];
          }
        }
      }
    }
  }

  public downloadItem() {
    api.downloadFile(this.$store, this.apiDownloadUrl);
  }

  public previewItem() {
    const ref: any = this.$refs.docpreview;
    ref.open(this.apiDownloadUrl);
  }

  public async deleteItem() {
    await api.deleteRecord(this.$store, this.apiDownloadUrl);
    this.$emit('reload');
  }

  public isEmpty(obj) {
    if (obj) {
      return Object.keys(obj).length === 0;
    } else {
      return true;
    }
  }

  public openGoogleMaps(value) {
    const coords: any = formatting.formatCoordinates(value);
    if (coords) {
      let link = 'https://www.google.com/maps/search/?api=1';
      link += '&query=' + coords.lat + ',' + coords.lon;
      window.open(link, '_blank');
    }
  }
  public handleCurrentPositionOk(position) {
    console.log('handleCurrentPositionOk', position);
    this.geoSubscriptionId = navigator.geolocation.watchPosition(this.handlePositionOk, this.handlePositionError, {maximumAge: 0, timeout: Infinity, enableHighAccuracy: true});
    this.handlePositionOk(position);
  }
  public handlePositionOk(position) {
    console.log('handlePositionOk', position);
    if (this.geoSubscriptionTimeStamp === 0) {
      this.geoSubscriptionTimeStamp = position.timestamp;
    }
    const elapsed = (position.timestamp - this.geoSubscriptionTimeStamp) / 1000;
    const newval = Math.round(position.coords.latitude * 1000000) / 1000000 + ' ' + Math.round(position.coords.longitude * 1000000) / 1000000;
    if (this.rec[this.field] !== newval) {
      this.rec[this.field] = newval;
      commitAddNotification(this.$store, {content: elapsed + 's Accuracy: ' + position.coords.accuracy + ' m', color: 'ok'});
    }

    console.log('geoId', this.geoSubscriptionId, 'Elapsed', elapsed, 'Accuracy', position.coords.accuracy);
    if (elapsed  > 20) {
      this.unregisterWatchPosition();
    }
  }
  public unregisterWatchPosition() {
    if (this.geoSubscriptionId) {
      navigator.geolocation.clearWatch(this.geoSubscriptionId);
      this.geoSubscriptionId = this.geoSubscriptionTimeStamp  = 0;
      console.log('Unsubscribe');
    }
  }
  public handlePositionError(error) {
    console.log('handlePositionError', error);
    if (error.code === 1) {
      commitAddNotification(this.$store, {content: 'Fout: geolocation API niet ondersteund door browser', color: 'error'});
    } else {
      commitAddNotification(this.$store, {content: error.message, color: 'error'});
    }
    this.unregisterWatchPosition();
  }
  public retrieveCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.handleCurrentPositionOk, this.handlePositionError, {maximumAge: 0, timeout: Infinity, enableHighAccuracy: true});
    } else {
      console.log('retrieveCurrentLocation: Missing geolocation API');
    }
  }

  // Lifecycle Functions
  public created() {
    // console.log('created', this.label);
    this.setOptions();
    this.$watch(
      'optionListParams',
      function(newValue, oldValue) {
          // console.log('DetailField.$watch optionListParams', oldValue, '->',  newValue);
          if (!this.isEmpty(oldValue) || !this.isEmpty(newValue)) {
            // Reset values and selected value when parameters changed
            if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
              this.setOptions();
              this.$emit('clear');
            }
          }
        }
    );
    // this.$watch(
    //   function() { return this.rec[this.field]; },
    //   function(newValue, oldValue) {
    //       console.log('DetailField.$watch ', this.field, oldValue, '->',  newValue);
    //       if (!this.isEmpty(oldValue) || !this.isEmpty(newValue)) {
    //       }
    //     }
    // );
  }

  public updated() {
    document
      .querySelectorAll('.v-input__icon--clear button')
      .forEach(x => x.setAttribute('tabindex', '-1'));
  }
}
